import { Link } from "react-router-dom";

export const jobText = (j) => [j.customer_name, j.job_name || j.job_number].filter(Boolean).join(" · ");

export function JobTitle({ j, link = true, testid }) {
  const name = j.job_name || (j.job_id || j.id ? j.job_number : "Business (general admin)");
  const inner = (
    <div className="min-w-0" data-testid={testid}>
      {j.customer_name && <div className="text-[11px] text-muted-foreground truncate">{j.customer_name}</div>}
      <div className="font-semibold truncate">{name}{j.job_number && j.job_number !== "BUSINESS" && <span className="ml-1.5 font-mono-num text-[10px] text-muted-foreground font-normal">{j.job_number}</span>}</div>
    </div>
  );
  const id = j.job_id || j.id;
  return link && id ? <Link to={`/jobs/${id}`} className="hover:text-primary transition-colors block min-w-0">{inner}</Link> : inner;
}
